/**
 * BasicInfoSection — Event detail fields displayed in a pp-field-grid.
 *
 * Props:
 *   eventData        — main event record object
 *   isReasonEditable — boolean (show edit icon next to reason)
 *   onEditReason     — () => void
 *   tzOffset         — timezone offset for datetime display
 */

import { Link } from 'react-router-dom';
import { convertIsoToLocal, getDeviceProfileLink } from '../../../../libs.jsx';

const BasicInfoSection = ({ eventData, isReasonEditable, onEditReason, tzOffset }) => {
    if (!eventData) return null;

    const d = eventData;

    // Device profile link — combo of manufacture_id + device_type_id (mirrors
    // DevicesPage); null when the device has no profile page.
    const deviceLink = getDeviceProfileLink(d);

    return (
        <div className="pp-section">
            <div className="pp-section__header">
                <h3 className="pp-section__title">Event Information</h3>
            </div>
            <div className="pp-section__body">
                <div className="pp-field-grid">
                    {/* Event Category */}
                    <div className="pp-field">
                        <span className="pp-field__label">Event Category</span>
                        <span className="pp-field__value">{d.event_category_name || '\u2014'}</span>
                    </div>

                    {/* Event Type */}
                    <div className="pp-field">
                        <span className="pp-field__label">Event Type</span>
                        <span className="pp-field__value">{d.event_type_name || '\u2014'}</span>
                    </div>

                    {/* Reason */}
                    <div className="pp-field">
                        <span className="pp-field__label">Reason</span>
                        <span className="pp-field__value">
                            {d.reason_code_description || 'No Reason'}
                            {isReasonEditable ? (
                                <button
                                    type="button"
                                    className="ep-edit-reason-btn"
                                    onClick={onEditReason}
                                    title="Edit Reason"
                                >
                                    <i className="fe fe-edit-2" aria-hidden="true" />
                                </button>
                            ) : null}
                        </span>
                    </div>

                    {/* Device */}
                    <div className="pp-field">
                        <span className="pp-field__label">Device</span>
                        {deviceLink ? (
                            <Link to={deviceLink} className="pp-field__value pp-field__value--link">
                                {d.device_name || '\u2014'}
                            </Link>
                        ) : (
                            <span className="pp-field__value">{d.device_name || '\u2014'}</span>
                        )}
                    </div>

                    {/* Device Serial */}
                    <div className="pp-field">
                        <span className="pp-field__label">Device Serial</span>
                        <span className="pp-field__value pp-field__value--mono">{d.manufacture_uuid || '\u2014'}</span>
                    </div>

                    {/* Area */}
                    <div className="pp-field">
                        <span className="pp-field__label">Area</span>
                        {d.area_id ? (
                            <Link to={`/profiles/area/${d.area_id}`} className="pp-field__value pp-field__value--link">
                                {d.area_name || '\u2014'}
                            </Link>
                        ) : (
                            <span className="pp-field__value">{d.area_name || '\u2014'}</span>
                        )}
                    </div>

                    {/* Area Type */}
                    <div className="pp-field">
                        <span className="pp-field__label">Area Type</span>
                        <span className="pp-field__value">{d.area_type_description || '\u2014'}</span>
                    </div>

                    {/* Resident */}
                    <div className="pp-field">
                        <span className="pp-field__label">Resident</span>
                        {d.resident_id ? (
                            <Link to={`/profiles/resident/${d.resident_id}`} className="pp-field__value pp-field__value--link">
                                {d.resident_name || '\u2014'}
                            </Link>
                        ) : (
                            <span className="pp-field__value">{d.resident_name || '\u2014'}</span>
                        )}
                    </div>

                    {/* Accepted By */}
                    <div className="pp-field">
                        <span className="pp-field__label">Accepted By</span>
                        <span className="pp-field__value">
                            {d.user_id ? (
                                <Link to={`/profiles/user/${d.user_id}`} className="pp-field__value pp-field__value--link">
                                    {d.display_name || '\u2014'}
                                </Link>
                            ) : (
                                <span className="pp-field__value">{d.display_name || '\u2014'}</span>
                            )}
                        </span>
                    </div>

                    {/*/!* Response Time *!/*/}
                    {/*<div className="pp-field">*/}
                    {/*    <span className="pp-field__label">Response Time</span>*/}
                    {/*    <span className="pp-field__value">*/}
                    {/*        {d.response_time != null ? `${d.response_time} min` : '\u2014'}*/}
                    {/*    </span>*/}
                    {/*</div>*/}

                    {/*/!* Service Time *!/*/}
                    {/*<div className="pp-field">*/}
                    {/*    <span className="pp-field__label">Service Time</span>*/}
                    {/*    <span className="pp-field__value">*/}
                    {/*        {d.service_time != null && d.service_time !== 0 && d.service_time !== '0' && d.service_time !== '0.0'*/}
                    {/*            ? `${d.service_time} min`*/}
                    {/*            : '\u2014'}*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

export default BasicInfoSection;
